import { lazy } from 'react';

export const TwoFactorVerifyPage = lazy(() => import('./TwoFactorVerifyPage'));
